module.exports = __webpack_public_path__ + "static/media/10@1024w.5f4dd665.jpg";